import React from 'react';
import { useTranslation } from 'react-i18next';

import { Server, RefreshCw, AlertTriangle } from 'lucide-react';
function ServerErrorPage() {
  const { t } = useTranslation('errorpage');

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div data-testid="server-error-container" className="fixed inset-0 bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div data-testid="server-error-content" className="text-center w-full max-w-xs sm:max-w-sm md:max-w-md">
        {/* Animated Server Icon */}
        <div data-testid="server-error-icon-wrapper" className="relative mb-3 sm:mb-4">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-full animate-pulse"></div>
          </div>
          <div className="relative flex items-center justify-center">
            <Server data-testid="server-error-icon" className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-teal-600 animate-pulse" />
            <AlertTriangle data-testid="server-error-alert-icon" className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 absolute -top-1 -right-1 animate-bounce" />
          </div>
        </div>

        {/* Title */}
        <h1 data-testid="server-error-title" className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent mb-2">
          {t('errorpage.server_down_title', 'Server Down')}
        </h1>

        {/* Message */}
        <p data-testid="server-error-message" className="text-sm sm:text-base text-gray-700 mb-3 font-medium">
          {t('errorpage.server_down_message', 'Service temporarily unavailable')}
        </p>

        {/* Suggestion */}
        <div data-testid="server-error-suggestions" className="bg-white/90 backdrop-blur-sm rounded-xl p-3 sm:p-4 mb-3 shadow-lg border border-teal-200">
          <ul className="text-left text-xs sm:text-sm text-gray-600 space-y-1">
            <li data-testid="server-error-step-1" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.server_down_step1', 'Wait and try again')}</span>
            </li>
            <li data-testid="server-error-step-2" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.server_down_step2', 'Check internet connection')}</span>
            </li>
            <li data-testid="server-error-step-3" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.server_down_step3', 'Contact support')}</span>
            </li>
          </ul>
        </div>

        {/* Status Info Box */}
        <div data-testid="server-error-status-box" className="bg-gradient-to-r from-teal-100 to-cyan-100 rounded-lg p-2 sm:p-3 mb-4 border border-teal-200">
          <div className="flex items-center justify-center gap-1.5 text-teal-700">
            <AlertTriangle data-testid="server-error-status-icon" className="w-3 h-3 sm:w-4 sm:h-4" />
            <p data-testid="server-error-status-text" className="text-xs font-medium">
              {t('errorpage.server_status_message', 'Under Maintenance')}
            </p>
          </div>
        </div>

        {/* Retry Button */}
        <button
          data-testid="server-error-retry-button"
          onClick={handleRetry}
          className="group inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg text-xs sm:text-sm transition-all duration-200 hover:scale-105 active:scale-95 cursor-pointer"
        >
          <RefreshCw data-testid="server-error-retry-icon" className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:rotate-180 transition-transform duration-300" />
          {t('errorpage.retry_server_button', 'Try Again')}
        </button>
      </div>
    </div>
  );
}

export default ServerErrorPage;
